<template>
    <div class="Component Department" v-if="!isCompanyUndefinedAllowed || departments.length">
        <div ref="dropdown" class="dropdown" v-if="this.mode == 'dropdown'">
            <template v-if="!unauthorized && department && departments.length">
                <button class="dropdown-toggle" :class="{active: isDropdownActive, useHand: !!departments.length }" type="button" @click="handleDropdownClick($event)">
                    <span class="Element Department Item" :class="mode">
                        <span class="inner">
                            <span class="abbreviation" :style="`--bgcolor: ${abbreviation(department_title(department)).color}`">{{ abbreviation(department_title(department)).letter }}</span>
                            <span class="title">{{ department_title(department) }}</span>
                            <Icon name="angle" />
                        </span>
                    </span>
                </button>
                <div v-if="departments.length" class="dropdown-menu" :class="{open: isDropdownActive}">
                    <section class="Element Overview Department" :class="mode">
                        <div class="input-group" v-if="departments.length > 5">
                            <input class="input form-control" :placeholder="trans('Zoeken')" type="text" v-model="search" ref="searchInputRef">
                            <div class="input-group-append">
                                <button type="button" class="btn">
                                    <Icon name="search" />
                                </button>
                            </div>
                        </div>
                        <ul class="block-grid" :class="mode == 'dropdown' ? 'one-up' : 'four-up'">
                            <li v-for="item in filter(departments)">
                                <article :key="department_uuid(item)" class="Element Department Item useHand" :class="{[mode]: true, 'active': isDepartmentActive(item) }" @click.prevent="handleDepartmentClick(item)">
                                    <div class="inner">
                                        <div class="abbreviation" :style="`--bgcolor: ${abbreviation(department_title(item)).color}`">{{ abbreviation(department_title(item)).letter }}</div>
                                        <span class="title">{{ department_title(item) }}</span>
                                    </div>
                                </article>
                            </li>
                        </ul>
                        <div class="empty" v-if="!filter(departments)?.length">
                            {{ trans("Geen resultaten gevonden.") }} <u v-if="departments.length" class="useHand" @click.stop="resetSearch">{{ trans("Reset") }}</u>
                        </div>
                    </section>
<!--                    <nav>-->
<!--                        <button type="button" class="more bg2">-->
<!--                            <span class="title">+ {{ trans("%s toevoegen", trans("Department") ) }}</span>-->
<!--                        </button>-->
<!--                    </nav>-->
                </div>
            </template>
            <template v-else>
                <button class="dropdown-toggle disabled" type="button" :disabled="true">
                    <span class="Element Department Item" :class="mode">
                        <span class="inner">
                            <span class="abbreviation" :style="`--bgcolor: ${abbreviation('...').color}`">...</span>
                            <span class="title">...</span>
                        </span>
                    </span>
                </button>
            </template>
        </div>
    </div>
</template>

<script>
import {defineComponent, inject, ref, computed, onMounted } from "vue";

import { abbreviation } from "helpers/_theme";
import trans from "helpers/_translation";

import Icon from "components/icon";

import { unauthorized, isCompanyUndefinedAllowed } from "store/portal";

import {
    initDepartments,
    departments,
    department,
    department_title,
    department_uuid,
    setActive,
    setActiveByUuid,
    isDepartmentActive
} from "store/department";

import { env } from "config";

export default defineComponent({
    name: "department",
    computed: {
        isCompanyUndefinedAllowed() {
            return isCompanyUndefinedAllowed
        }
    },
    methods: {department_uuid},
    props: {
        mode: {
            type: String,
            required: false,
            default: "dropdown"
        }
    },
    components: {
        Icon
    },
    setup() {

        const searchInputRef = ref();
        const search = ref("");
        const resetSearch = () => {
            search.value = "";
        };

        const dropdown = ref();
        const isDropdownActive = ref(false);
        const catchOutsideClick = (e) => {
            if (!dropdown.value) return;
            // When user clicks menu — do nothing
            if (dropdown.value === e.target || dropdown.value.contains(e.target)) return false;

            // When user clicks outside of the menu — close the menu
            if (isDropdownActive.value && dropdown !== e.target && !dropdown.value.contains(e.target)) return true;
        };
        const handleDropdownClick = (e) => {
            // Block any events when dropdown isn't active
            if (departments.value.length === 0) return;
            // Toggle dropdown
            isDropdownActive.value = !isDropdownActive.value;
            const closeListener = (e) => {
                if (catchOutsideClick(e, dropdown.value)) {
                    window.removeEventListener('click', closeListener);
                    isDropdownActive.value = false;
                }
            };
            if (isDropdownActive.value) {
                window.addEventListener('click', closeListener);
                setTimeout(() => {
                    searchInputRef.value?.focus();
                }, 100);
            } else {
                window.removeEventListener('click', closeListener);
            }
        };
        const resetDropdown = () => {
            isDropdownActive.value = false;
        };

        const handleConfirm = inject("handleConfirm");
        const handleDepartmentClick = (department) => {
                handleConfirm().then(
                    () => {
                        resetDropdown();
                        setActive(department);
                        setTimeout(() => {
                            resetSearch();
                        }, 100);
                    },
                    () => {

                    }
                );
        };

        const filter = (values) => {
            return computed(() => {
                return values.filter((value) => {
                    const title = department_title(value);
                    return title?.toLowerCase().includes(search.value.toLowerCase());
                });
            }).value;
        };

        onMounted(initDepartments);

        return {
            isCompanyUndefinedAllowed,

            search,
            searchInputRef,
            resetSearch,

            filter,

            env,
            dropdown,

            unauthorized,

            handleDropdownClick,
            isDropdownActive,
            trans,

            abbreviation,

            department,
            departments,
            department_title,

            isDepartmentActive,

            handleDepartmentClick
        };
    },
});
</script>